import React, {Component} from 'react';
import ArrowButton from "../../../common/button-arrow";
import {Checkbox, Col, FormControl, Row} from "react-bootstrap";
import {Errors, Form} from "react-redux-form";
import RequiredInput from "../../../common/form/elements/required-input";
import { connect } from 'react-redux';

class GroupForm extends Component {
  render() {
    const {formValid, model, onSubmit} = this.props;

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid">
          <Form model={model} onSubmit={onSubmit}>
            <Row>
              <Col md={12}>
                <Errors className="errors" model={model}/>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput label="Name"
                               placeholder="Name"
                               model='.name'
                               controlId='name'/>
              </Col>
            </Row>
            <Row>
              <Col md={2} mdOffset={10}>
                <ArrowButton className="pull-right"
                             arrow={false}
                             disabled={!formValid}>Save</ArrowButton>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValid: state.deep.forms.admin_group_save.$form.valid,
});

export default connect(mapStateToProps)(GroupForm);


// WEBPACK FOOTER //
// ./src/components/admin/groups/form/group-form.jsx